import React, { useEffect, useState } from 'react';
import { getAvailableTimes } from '../api';

const WEEKDAY_FULL = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];

export default function StepTime({ service, date, onSelect, onBack }) {
    const [times, setTimes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getAvailableTimes(service.id, date)
            .then(setTimes)
            .catch(() => setTimes([]))
            .finally(() => setLoading(false));
    }, [service.id, date]);

    const formatDate = (iso) => {
        const [y, m, d] = iso.split('-');
        return `${d}.${m}.${y}`;
    };

    if (loading) {
        return <div className="loading"><div className="spinner" /></div>;
    }

    return (
        <div>
            <button className="btn-back" onClick={onBack}>
                &larr; {service.service_type === 'WEEKLY' ? WEEKDAY_FULL[new Date(date).getDay()] : formatDate(date)}
            </button>
            <div className="section-title">Выберите время</div>

            {times.length === 0 ? (
                <div className="loading"><p>Нет доступных слотов на эту дату</p></div>
            ) : (
                <div className="time-grid">
                    {times.map(t => (
                        <div
                            key={t.time}
                            className={`time-slot${!t.is_available ? ' disabled' : ''}`}
                            onClick={() => t.is_available && onSelect(t.time)}
                        >
                            <div className="time-value">{t.time}</div>
                            <div className="time-info">
                                {t.available > 0 ? `${t.available} мест` : 'Занято'}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
